var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "30px",
    height: "30px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#67b173",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(8.53333,8.53333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,6c-3.182,0 -4.5,2.041 -4.5,4.5c0,0.828 0.39648,1.66016 0.39648,1.66016c-0.159,0.092 -0.42342,0.38439 -0.35742,0.90039c0.123,0.962 0.54064,1.20461 0.80664,1.22461c0.101,0.898 1.0673,2.04784 1.4043,2.21484v1.3418c-0.75,2.25 -6.75,1.9082 -6.75,7.1582h18c0,-5.25 -6,-4.9082 -6.75,-7.1582v-1.3418c0.338,-0.167 1.3033,-1.31684 1.4043,-2.21484c0.266,-0.02 0.68364,-0.26261 0.80664,-1.22461c0.066,-0.517 -0.19842,-0.80839 -0.35742,-0.90039c0,0 0.39648,-0.75116 0.39648,-1.66016c0,-1.821 -0.715,-3.375 -2.25,-3.375c0,0 -0.533,-1.125 -2.25,-1.125zM22.5,7.99805c-0.512,0 -0.94766,0.09261 -1.34766,0.22461c0.219,0.679 0.34766,1.43634 0.34766,2.27734c0,0.532 -0.08345,1.01973 -0.18945,1.42773c0.145,0.429 0.19481,0.90077 0.13281,1.38477c-0.141,1.101 -0.56847,1.84931 -1.10547,2.32031c-0.156,0.378 -0.36961,0.73612 -0.59961,1.07813c0.284,0.583 0.69972,1.10203 0.88672,1.20703v0.01172c2.037,0.955 5.375,2.56031 5.375,7.07031h4c0,-4.958 -5,-4.24609 -5.625,-6.37109v-0.71289c0.281,-0.158 1.08592,-1.2438 1.16992,-2.0918c0.221,-0.019 0.56987,-0.24725 0.67188,-1.15625c0.055,-0.488 -0.16487,-0.76261 -0.29687,-0.84961c0,0 0.33008,-0.71136 0.33008,-1.56836c0,-1.72 -0.596,-3.1875 -1.875,-3.1875c0,0 -0.444,-1.06445 -1.875,-1.06445zM7.5,8c-1.431,0 -1.875,1.0625 -1.875,1.0625c-1.279,0 -1.875,1.46945 -1.875,3.18945c0,0.858 0.33008,1.56641 0.33008,1.56641c-0.133,0.086 -0.35187,0.36161 -0.29687,0.84961c0.102,0.909 0.45087,1.1392 0.67187,1.1582c0.084,0.848 0.88892,1.9338 1.16992,2.0918v0.71094c-0.625,2.124 -5.625,1.41309 -5.625,6.37109h4c0,-4.51 3.338,-6.11431 5.375,-7.07031v-0.01367c0.187,-0.105 0.60272,-0.62108 0.88672,-1.20508c-0.23,-0.342 -0.44361,-0.70208 -0.59961,-1.08008c-0.537,-0.47 -0.96547,-1.21836 -1.10547,-2.31836c-0.063,-0.49 -0.01128,-0.96934 0.13672,-1.40234c-0.108,-0.411 -0.19336,-0.89916 -0.19336,-1.41016c0,-0.827 0.11708,-1.58725 0.33008,-2.28125c-0.395,-0.129 -0.82508,-0.21875 -1.33008,-0.21875z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/Social.7ce2444691d744c3df6fba758074724c.svg";
export { ForwardRef as ReactComponent };